import { Getter } from "vuex";
import { IState } from './state';


const text: Getter<IState, IState> = (state) => state.puff.text;
const textColor: Getter<IState, IState> = (state) => state.puff.textColor;
const bgColor: Getter<IState, IState> = (state) => state.puff.bgColor;
const bgColorIcone: Getter<IState, IState> = (state) => state.puff.bgColorIcone;
const hasLink: Getter<IState, IState> = (state) => state.puff.hasLink;
const linkUrl: Getter<IState, IState> = (state) => state.puff.linkUrl;
const linkRel: Getter<IState, IState> = (state) => state.puff.linkRel;
const linkAltText: Getter<IState, IState> = (state) => state.puff.linkAltText;
const icone: Getter<IState, IState> = (state) => state.puff.icone;
const iconePil: Getter<IState, IState> = (state) => state.puff.iconePil;

export default {
	text,
	textColor,
	bgColor,
	bgColorIcone,
	hasLink,
	linkUrl,
	linkRel,
	linkAltText,
	icone,
	iconePil
}
